<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <div class="row">
            <CCol sm="6" class="align-self-center">
              <strong>Alumni Association</strong>
            </CCol>
            <CCol sm="6" class="align-self-center">
              <div class="text-sm-right mt-3 mt-sm-0">
                <CButtonGroup class="file-export">
                  <CButton color="secondary" disabled>
                    {{ $lang.buttons.export.title }}
                  </CButton>
                  <CButton
                      color="danger"
                      v-c-tooltip="$lang.buttons.export.pdf"
                      v-on:click="exports(this, 'pdf', module, 'Alumni')"
                  >
                    <i class="fas fa-file-pdf"></i>
                  </CButton>
                  <VueJsonToCsv
                      class="btn btn-success"
                      v-c-tooltip="$lang.buttons.export.excel"
                      :json-data="json_data"
                      :labels="json_label"
                      :csv-title="json_title"
                  >
                    <i class="fas fa-file-excel"></i>
                  </VueJsonToCsv>
                </CButtonGroup>
              </div>
            </CCol>
          </div>
        </CCardHeader>
        <CCardBody>
          <CAlert
              :color="messageColor"
              closeButton
              :show.sync="dismissCountDownS"
              fade
          >{{ alertMessage }}
          </CAlert
          >
          <v-server-table
              :columns="columns"
              url="/alumni/list"
              :options="options"
              ref="myTable"
          >
            <template #status="data">
              <CBadge :color="statusBudget(data.row.status)" v-if="data.row.status == 0">Pending</CBadge>
              <CBadge :color="statusBudget(data.row.status)" v-if="data.row.status == 1">Approved</CBadge>
              <CBadge :color="statusBudget(data.row.status)" v-if="data.row.status == 2">Rejected</CBadge>
            </template>
            <template #isRegistered="data">
              <CBadge :color="statusBudget(data.row.isRegistered)" v-if="data.row.isRegistered == 0">No</CBadge>
              <CBadge :color="statusBudget(data.row.isRegistered)" v-if="data.row.isRegistered == 1">Yes</CBadge>
            </template>
            <template #actions="data">
              <CButton
                  color="success"
                  v-c-tooltip="$lang.buttons.general.crud.view"
                  v-on:click="viewTableRow(data.row.id)"
              >
                <i class="fas fa-eye"></i>
              </CButton>
              <CButton
                  color="primary"
                  v-c-tooltip="$lang.buttons.general.crud.view"
                  v-on:click="viewMember(data.row.id)"
              >
                <i class="fas fa-eye"></i>
              </CButton>
            </template>
          </v-server-table>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>
<script>
import Vue from "vue";
import VueForm from "vue-form";
import {alumni} from "/src/store/url.js";
import {Mixin} from "/src/mixins/index.js";
import options from "/src/validations/validations.js";
import {ServerTable} from "vue-tables-2";
import VueSweetalert2 from "vue-sweetalert2";
import {minLength, required} from "vuelidate/lib/validators";
import VueJsonToCsv from "vue-json-to-csv";
import {Maxlength} from "../../store/maxlength";
import store from "@/store/store";

Vue.use(VueSweetalert2);
Vue.use(ServerTable, {}, false);
Vue.use(VueForm, options);

export default {
  name: "AlumniItem",
  mixins: [Mixin],
  components: {
    VueJsonToCsv,
  },
  data() {
    return {
      submitted: false,
      json_data: [],
      json_label: {},
      messageColor: "success",
      json_title: "",
      err_msg: "",
      largeModal: false,
      submitType: "",
      alertMessage: "test",
      showAlert: false,
      dismissCountDown: 0,
      dismissCountDownS: 0,
      self: this,
      msg: "",
      items: [],
      activePage: 1,
      module: alumni,
      alumni: {
        title: "",
        isActive: 1,
        showToResource: 0,
      },
      maxlength: {
        title: Maxlength.alumni.title,
      },
      columns: ["associationName", "address","isRegistered","email","status", "actions"],
      data: [],
      options: {
        headings: {
          associationName: "Title",
          email: "Email",
          status: "status",
          isRegistered: "Is Registered",
          address: "Address",
          actions: "Actions",
        },
        editableColumns: ["title"],
        sortable: ["title", "status"],
        filterable: ["title", "status"],
      },
    };
  },
  validations: {
    alumni: {
      title: {
        required,
        minLength: minLength(1),
      },
    },
  },
  mounted() {
    let self = this;
    // this.loadData();
    store.commit('showLoader', false);
    self.dismissCountDown = 0;
    self.dismissCountDownS = 0;
    if (localStorage.getItem("showAlert") !== "") {
      this.setAlert(true);
    }
    this.setAlert(false);
    localStorage.setItem("showAlert", "");
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (route.query && route.query.page) {
          this.activePage = Number(route.query.page);
        }
      },
    },
  },
  methods: {
    setAlert(value) {
      this.showAlert = value;
    },
    viewTableRow(item) {
      let self = this;
      self.$v.$reset();
      self.submitType = "Update";
      self.editId = item;
      this.$router.push({path: `alumni/view/${item}`});
    },
    viewMember(item) {
      let self = this;
      self.editId = item;
      this.$router.push({path: `alumni/view/member/${item}`});
    },
    rowClicked(item, index) {
      this.$router.push({path: `alumni/view/${item}`});
    },
    pageChange(val) {
      this.$router.push({query: {page: val}});
    },
    loadData() {
      let self = this;
      axios
          .get(this.listUrlApi(this.module), self.model)
          .then(function (response) {
            if (response) {
              self.data = response.data;
            } else {
              self.data = [];
            }
          });
    },
  },
};
</script>
